module.exports = __webpack_public_path__ + "img/default.44b1c173.svg";